//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

(function() {
  const content = angular.module('curalate');

  content.component('contentLibrarySemanticTagsFilterSection', {
    bindings: {
      collectionId: '<',
    },
    require: {
      searchFilterSet: '^searchFilterSet',
    },
    template: require('@legacy-components/content/content-library-semantic-tags-filter-section.html'),
    controller: [
      'AutocompleteTypes',
      'ContentLibraryApiService',
      'ContentSearchTypes',
      'SearchFilterService',
      'TrackingService',
      'SEARCH_FILTERS',
      'rx',
      function(
        AutocompleteTypes,
        ContentLibraryApiService,
        ContentSearchTypes,
        SearchFilterService,
        TrackingService,
        SEARCH_FILTERS,
        rx,
      ) {
        const self = this;

        const currentHashtags = [];
        const currentUsers = [];

        const filters = {};

        const ngUnsubscribe = new rx.Subject();
        let suggestionPromise;

        this.trackingCategory = TrackingService.CATEGORY_LIBRARY;

        this.getContentSuggestionsAsync = async function(query) {
          const params = {
                        // Overwritten by the object unpacking, if the field exists.
                        // This defaults to "All" on the backend, which is all touched media (tagged, rights requested, etc...)
            contentGroup: 'Nothing',
            ...filters,
            collectionId: self.collectionId,
            f_hashtags: currentHashtags.join(','),
            f_users: currentUsers.join(','),
          };

          if (suggestionPromise) {
            suggestionPromise.abort();
            suggestionPromise = null;
          }

          suggestionPromise = ContentLibraryApiService.getVisualTagsSuggestionsAsync(
                        AutocompleteTypes.VISUAL_TAGS,
                        query,
                        params,
                    ).then((resp) => {
                      return {
                        tags: resp.visualTags,
                      };
                    });
          suggestionPromise.finally(() => {
            suggestionPromise = null;
          });

          return suggestionPromise;
        };

        const handleContentSourcesUpdate = function(setUpdate) {
          if (setUpdate && setUpdate.setObject) {
            _(filters).extend(angular.copy(setUpdate.setObject));
          }
        };

        const handleContentFiltersUpdate = function(setUpdate) {
          if (setUpdate && setUpdate.setObject) {
            const contentFilters = _(setUpdate.setObject).omit(['semanticTags']);

            _(filters).extend(contentFilters);
          }
        };

        this.extractFilterValue = function(filterObj) {
          return filterObj.value;
        };

        const processSemanticTagSetUpdate = function(setUpdate) {
          const semanticTags = setUpdate.setObject.semanticTags;
          const contentFilters = _(setUpdate.setObject).omit('semanticTags');

          return _(contentFilters).extend({
            semanticTags: _(semanticTags).map((semanticTag) => {
              return { tag: semanticTag.value || semanticTag.tag };
            }),
          });
        };

        this.$onInit = function() {
          SearchFilterService.transformFilterSet(
            SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS_PROCESSED,
            SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS,
            processSemanticTagSetUpdate,
          );

          // Initialize starting value for the current state of the world
          const filtersSet = SearchFilterService.getRegisteredSet(SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS_PROCESSED);
          handleContentFiltersUpdate({
            setObject: filtersSet.params || {},
          });
          const sourcesSet = SearchFilterService.getRegisteredSet(SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS);
          handleContentSourcesUpdate({
            setObject: _(sourcesSet).safeGet('params') || {},
          });

          SearchFilterService.getObservableForFilterSet(
            SEARCH_FILTERS.COLLECTION_CONTENT_FILTERS_PROCESSED,
          ).takeUntil(ngUnsubscribe).subscribe(handleContentFiltersUpdate);

          SearchFilterService.getObservableForFilterSet(
            SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS,
          ).takeUntil(ngUnsubscribe).subscribe(handleContentSourcesUpdate);
        };

        self.$onDestroy = function() {
          ngUnsubscribe.next();
          ngUnsubscribe.complete();
        };
      },
    ],
  });
})();
